<div *ngIf="isAuthenticated === false" 
	class="cm-global-header--public">

	<!-- mobile version -->
	<div class="cm-global-header--public__mobile">
		<img alt="CropManage Logo"
			class="bk-clickable"
			(click)="onClickHomePage()"
			src="assets/images/logos/cropmanage-logo-v2.png" height="71"/>
		<button mat-button [matMenuTriggerFor]="mainPublicMenu">
			<i class="fa fa-bars" aria-hidden="true"></i>
		</button>
		<mat-menu #mainPublicMenu="matMenu">
			<mobile-menu-public></mobile-menu-public>
		</mat-menu>
	</div>
	
	<!-- desktop version -->

	<div class="cm-global-header--public__inner">
		<div class="cm-global-header--public__left">
			<img alt="CropManage Logo"
				class="bk-clickable"
				(click)="onClickHomePage()"
				src="assets/images/logos/cropmanage-logo-v2.png" height="71"/>

			<div class="cm-global-header--public__menu">
				<a class="cm-menu-link" routerLink="/getting-started">
					Getting Started
				</a>
				<a class="cm-menu-link" routerLink="/about-us">
					About Us
				</a>
				<div>
					<a class="cm-menu-link" [matMenuTriggerFor]="menu">Calculators</a>
					<mat-menu #menu="matMenu" class="cm-menu--large">
						<button mat-menu-item routerLink="/et-calculator">
							<span>Seasonal ET Calculator</span>
						</button>
						<button mat-menu-item routerLink="/ir-calculator">
							<span>Irrigation Calculator</span>
						</button>
						<button mat-menu-item routerLink="/n-calculator">
							<span>Nitrogen Calculator</span>
						</button>
					</mat-menu>
				</div>
				<a routerLink="/web-api" class="cm-menu-link">API</a>
			</div>
		</div>

		<div class="cm-global-header--public__right">
			<button class="cm-button--secondary"
				routerLink="/login">Log In
			</button>
			<button class="cm-button--primary"
				routerLink="/register">Get Started for Free
			</button>
		</div>
	</div>

</div>

<div *ngIf="isAuthenticated"
	class="global-header bk-header">

	<button class="bk-button bk-header__menu-icon bk-header__item"
		mat-button [matMenuTriggerFor]="mainMenu">
		<i class="fa fa-bars cm-main-menu-icon" aria-hidden="true"></i>{{'Menu' | translate }}
	</button>
	<mat-menu #mainMenu="matMenu">
		<main-menu></main-menu>
	</mat-menu>
	<!-- logo -->
	<div class="app-title bk-header__logo bk-header__item" (click)="goToDashboard()">
		<img alt="CropManage" src="assets/images/logos/cropmanage-logo-black.png" width="162" height="30" />
	</div>

	<div id="bk-menu--mobile">
		<button mat-button [matMenuTriggerFor]="matMenuMobile">
			<mat-icon aria-hidden="false" aria-label="menu">more_vert</mat-icon>
		</button>
		<mat-menu #matMenuMobile="matMenu">
			<button mat-menu-item
				[matMenuTriggerFor]="supportMobile">
				<mat-icon aria-hidden="false" aria-label="Contact Support">help</mat-icon>
				{{ 'Support' | translate }}
			</button>
			<button mat-menu-item
				[matMenuTriggerFor]="languagesMobile">
				<mat-icon aria-hidden="false" aria-label="Language">language</mat-icon>
				{{ languageName }}
			</button>
		</mat-menu>

		<mat-menu #supportMobile="matMenu">
			<button mat-menu-item
				(click)="openTechnicalSupport()">
				<mat-icon aria-hidden="false" aria-label="Contact Support">help</mat-icon>
				<span>{{ 'Technical Support' | translate }}</span>
			</button>
			<button mat-menu-item
				(click)="openFeedbackDialog()">
				<mat-icon aria-hidden="false" aria-label="Contact Support">feedback</mat-icon>
				{{ 'Send Feedback' | translate }}</button>
			<button mat-menu-item
				(click)="openHelpDocumentation()">
				<mat-icon aria-hidden="false" aria-label="Contact Support">library_books</mat-icon>
				{{ 'Help Documentation' | translate }}
			</button>
		</mat-menu>

		<mat-menu #languagesMobile="matMenu">
			<button mat-menu-item *ngFor="let languageCode of languageCodes"
				(click)="setLanguage(languageCode.Id)">
				{{languageCode.Language | translate}}
			</button>
		</mat-menu>
	</div>

	<!-- horizontal menu -->
	<div class="bk-header__name-language-menu" *ngIf="user && languageCodes">
		<div class="bk-header__name bk-header__right_nav_item bk-header__item" (click)="navigateToProfile()">
			<span class="bk-header__icon cm-icon--with-text">
				<mat-icon aria-hidden="false" aria-label="Account">account_circle</mat-icon>
			</span>
			<span *ngIf="user">
				{{user.FirstName}} {{user.LastName}}
			</span>
		</div>
		<div class="bk-header__support bk-header__right_nav_item bk-header__item">
			<button mat-button [matMenuTriggerFor]="menu">
				<mat-icon class="cm-icon--with-text"
					aria-hidden="false"
					aria-label="Help">help_outline
				</mat-icon>
				<span class="cm-global-nav__support--desktop">{{ 'Support' | translate }}</span>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item
					(click)="openTechnicalSupport()">
					<mat-icon aria-hidden="false" aria-label="Contact Support">help</mat-icon>
					<span>{{ 'Technical Support' | translate }}</span>
				</button>
				<button mat-menu-item
					(click)="openFeedbackDialog()">
					<mat-icon aria-hidden="false" aria-label="Contact Support">feedback</mat-icon>
					{{ 'Send Feedback' | translate }}</button>
				<button mat-menu-item
					(click)="openHelpDocumentation()">
					<mat-icon aria-hidden="false" aria-label="Contact Support">library_books</mat-icon>
					{{ 'Help Documentation' | translate }}
				</button>
			</mat-menu>
		</div>
		<div class="language-select bk-header__language bk-header__right_nav_item bk-header__item">
			<span class="bk-header__icon cm-icon--with-select">
				<mat-icon aria-hidden="false" aria-label="Language">language</mat-icon>
			</span>
			<select class="bk-header__item__select cm-global-nav__localization--desktop"
				id="languageSelect" aria-label="Select Language"
				(ngModelChange)="setLanguage($event)"
				[(ngModel)]="translateService.currentLanguageId">
				<option *ngFor="let languageCode of languageCodes"
					[ngValue]="languageCode.Id">{{languageCode.Language | translate}}
				</option>
			</select>
		</div>
	</div>
</div>
